import { AsyncSelect } from '@creditflowresearch/uilib/Select';
import {
  useArticlesFilterContext,
} from '@/creditflowresearch/application/ArticlesAndStats/Articles/Filter/ArticlesFilterContext';
import { IMarketArticlesFilterPayload } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IMarketArticle';
import FilterSection from '@framework/ui/Organisms/Filters/components/FilterSection';
import { IOptionDeal } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IDeal';

interface ISidebarDealListProps {
  filterName: string,
  sectionId: number | string,
  sectionTitle: string,
  isVisible: boolean,
  onSectionToggle: (activeKey: number | string) => void,
  handleFilterUpdate: (filters: Partial<IMarketArticlesFilterPayload>) => void,
}

const MIN_LENGTH_QUERY = 3;

const SidebarDealsList = ({
  filterName,
  sectionId,
  sectionTitle,
  isVisible,
  onSectionToggle,
  handleFilterUpdate,
}: ISidebarDealListProps) => {
  const { deals: { selected, setSelected, currentOptions, loadDealsList } } = useArticlesFilterContext();

  const onChange = (selectedValues: IOptionDeal[]) => {
    handleFilterUpdate({ [filterName]: selectedValues.map((item) => item.value) });
    setSelected(selectedValues);
  };

  return (
    <FilterSection
      sectionId={ sectionId }
      headerComponent={ sectionTitle }
      isVisible={ isVisible }
      onSectionToggle={ onSectionToggle }
    >
      <AsyncSelect
        name="selectDeals"
        placeholder="Select a Deal"
        dataTest="selectDeals"
        value={ selected }
        onChange={ onChange }
        loadOptions={ loadDealsList }
        useDebounce={ { minInputLength: MIN_LENGTH_QUERY } }
        defaultOptions={ currentOptions }
        hideSelectedOptions={ false }
        closeMenuOnSelect={ false }
        isMulti
        isNarrow
        isSupportHighlighting={ false }
        filterOption={ () => true }
      />
    </FilterSection>
  );
};

export default SidebarDealsList;
